import { useAuth } from "../../contexts/AuthContext";
import { useSidekickMinutesUsage } from "../../hooks/useSidekickMinutesUsage";
import { Notice } from "../ui";

// Billing already handles overage - this just tells admins it's happening, since
// nothing in the app blocks transcription once a customer is over their pool.
const SidekickMinutesBanner = ({ style }) => {
  const { apiUser } = useAuth();
  const { data: usage } = useSidekickMinutesUsage();

  if (!apiUser?.is_admin || !usage?.over_limit) {
    return null;
  }

  return (
    <Notice tone="error" style={style}>
      You've used all your Sidekick minutes for this period (
      {usage.used_minutes} of {usage.limit_minutes} minutes). Further usage this
      period will incur additional charges.
    </Notice>
  );
};

export default SidekickMinutesBanner;
